import { Button, ComboBoxDropdownFooterProps, NavListSeparator, useModal } from '@billy/design-system'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { ModalId } from '../../../../../../../../../../../../../../../../../../../enums/modalId'
import { useInvoiceEditorForm } from '../../../../../../../../../../../../../../../contexts/invoiceEditorFormContext'

export const ProductNameComboBoxDropdownFooter = ({ items, onDropdownClose }: ComboBoxDropdownFooterProps) => {
  const { t } = useTranslation()
  const { trackInvoiceEditor } = useInvoiceEditorForm()

  const { open } = useModal(ModalId.ProductEditorModal)

  const shouldShowSeparator = !!items?.length

  const handleCreateProductClick = useCallback(() => {
    trackInvoiceEditor('Form - Create item clicked')
    onDropdownClose?.()
    open()
  }, [onDropdownClose, open, trackInvoiceEditor])

  return (
    <>
      {shouldShowSeparator && <NavListSeparator />}
      <Button icon="circlePlus" variant="text" size="lg" fullWidth onClick={handleCreateProductClick}>
        {t('external_invoices.editor.form.field.line.field.product_name.create_product')}
      </Button>
    </>
  )
}
